import {
    NOTIFICATION_LOCATION_ON_PAGE,
    NOTIFICATION_TYPE,
} from './notification-config';

import {AppDownloadBannerWrapper} from './AppDownloadBanner/app-download-banner-wrapper';
import {AppDownloadModalWrapper} from './AppDownloadModal/app-download-modal-wrapper';
function getNotification(type) {
    switch (type) {
        case `${NOTIFICATION_LOCATION_ON_PAGE.PRE_HEADER}|${NOTIFICATION_TYPE.APP_DOWNLOAD}`:
            return AppDownloadBannerWrapper;
        case `${NOTIFICATION_LOCATION_ON_PAGE.PRE_HEADER}|${NOTIFICATION_TYPE.APP_HERO}`:
            return AppDownloadModalWrapper;
        default:
            return null;
    }
}

function getCustomerNotificationComponent(location, type) {
    let typeName = `${location}|${type}`;
    return getNotification(typeName);
}

export {getCustomerNotificationComponent};
